import { NgModule } from '@angular/core';
import { GenCartComponentsModule } from './cart-components.module';
import { GenCartBaseCoreModule } from './core/cart-base-core.module';

@NgModule({
  imports: [GenCartBaseCoreModule, GenCartComponentsModule],
})
export class GenCartBaseModule {}
